import * as actionTypes from '../actionTypes';
import { moduleTypes } from '../../util/constants';
import { getAxiosInstance } from '../../util/service';

/**
 * Invoice Search Actions (v2)
 *
 * Changes:
 *  - Removed getCompanyId()/isManagement() calls inside thunks
 *  - companyId & isManagement resolved from getState() via thunk
 *  - clearSearchData is synchronous (no unnecessary async)
 *  - Consistent error returns
 */

export const getSearchInvoiceList = (formObject) => {
    return async (dispatch, getState) => {
        const { authInfo } = getState();
        const companyId = authInfo.companyId || '';
        const isMgmt = authInfo.isManagement || false;
        const url = `dashboard/getInvoicesBasedOnFilter?companyId=${companyId}&isManagement=${isMgmt}`;
        try {
            const response = await getAxiosInstance(moduleTypes.DISPATCH).put(
                url, formObject, { headers: { 'Content-Type': 'application/json' } }
            );
            const list = (response.status === 200 && response.data.response) || [];
            dispatch({ type: actionTypes.GET_INVOICE_SEARCH_LIST, searchInvoiceList: list });
            return response.data;
        } catch (ex) {
            dispatch({ type: actionTypes.GET_INVOICE_SEARCH_LIST, searchInvoiceList: [] });
            return { statusCode: null, statusMsg: ex.message };
        }
    };
};

export const getChildList = (accountId) => {
    return async (dispatch, getState) => {
        const { authInfo } = getState();
        const mgmtCompanyId = authInfo.companyId || '';
        const url = `/invoice/companySelectOpt/${accountId || 0}?managementCompanyId=${mgmtCompanyId}`;
        try {
            const response = await getAxiosInstance(moduleTypes.DISPATCH).get(url);
            if (response.status === 200) {
                const type = (accountId || 0) === 0
                    ? actionTypes.LIST_OF_CHILD_COMP
                    : actionTypes.LIST_OF_ASSOCIATE_COMP;
                const key = (accountId || 0) === 0 ? 'childComList' : 'associateComp';
                dispatch({ type, [key]: response.data });
                return response.data;
            }
            dispatch({ type: actionTypes.LIST_OF_CHILD_COMP, childComList: [] });
            return response.data;
        } catch (ex) {
            dispatch({ type: actionTypes.LIST_OF_CHILD_COMP, childComList: [] });
            return { statusCode: null, statusMsg: ex.message };
        }
    };
};

// Synchronous — no async needed
export const clearSearchData = () => ({
    type: actionTypes.GET_INVOICE_SEARCH_LIST,
    searchInvoiceList: [],
});
